MOVE.LANDERS_NEWHOMES = (function (MOVE) {
  var init = function () {
  };

  MOVE.LANDERS_NEWHOMES =
  {
    init: init
  };

  return MOVE.LANDERS_NEWHOMES;
})(MOVE || {});



// WEBPACK FOOTER //
// ./landers_newhomesandconstruction/landers_newhomesandconstruction.js